import SEO from "@/components/SEO";

/**
 * Shared layout for static legal pages (Terms, Privacy, Refund).
 * Keeps typography consistent with the Blog Post style.
 */
export default function LegalPage({
  title,
  effectiveDate,
  description,
  path,
  children,
}) {
  return (
    <div data-testid={`legal-page-${path.replace(/\//g, "")}`} className="section-pad">
      <SEO
        title={title}
        description={description}
        path={path}
        keywords="weight loss gurukul legal, terms, privacy policy, refund policy, online yoga"
        noindex={false}
      />
      <div className="container-x max-w-3xl">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-3 font-serif text-4xl md:text-5xl text-forest leading-tight">
          {title}
        </h1>
        <p className="mt-3 text-sm text-ink-muted">
          Effective date: <span className="font-medium text-ink">{effectiveDate}</span>
        </p>

        <div className="mt-10 space-y-6 text-ink-soft leading-relaxed text-base md:text-[17px]">
          {children}
        </div>
      </div>
    </div>
  );
}

export function H2({ children }) {
  return (
    <h2 className="font-serif text-2xl md:text-3xl text-forest leading-tight pt-6">
      {children}
    </h2>
  );
}

export function P({ children }) {
  return <p>{children}</p>;
}

export function UL({ children }) {
  return <ul className="list-disc pl-6 space-y-2">{children}</ul>;
}
